import { API_JWT_BASE_URL } from '../http'

export const SEARCH_OTAP_AGENTS_API = `${API_JWT_BASE_URL}/admin/otapagents/search`
export const SEARCH_OTAP_AGENTS_SIMPLE_API = `${API_JWT_BASE_URL}/admin/otapagents/SimpleList`
export const GET_OTAP_AGENT_API = `${API_JWT_BASE_URL}/admin/otapagents/`
export const UPDATE_OTAP_AGENT_API = `${API_JWT_BASE_URL}/admin/otapagents/`
export const DELETE_OTAP_AGENT_API = `${API_JWT_BASE_URL}/admin/otapagents`

export const OTAP_AGENTS_QUERY_KEYS = {
  SEARCH_OTAP_AGENTS: 'SEARCH_OTAP_AGENTS',
  GET_OTAP_AGENT: 'GET_OTAP_AGENT',
  UPDATE_OTAP_AGENT: 'UPDATE_OTAP_AGENT',
  DELETE_OTAP_AGENT: 'DELETE_OTAP_AGENT'
}
